import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Button from 'components/button';

const SessionExpiredModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
  }, []);

  const handleReconnect = () => {
    localStorage.removeItem('xsrfToken');
    localStorage.removeItem('rUser');
    window.location.href = process.env.REACT_APP_ADMIN_LOGIN;
  };

  if (!visible) return null;

  return ReactDOM.createPortal(
    <>
      <div className="flex fixed justify-center items-center inset-0 z-[60] outline-none focus:outline-none">
        <div className="relative w-full max-w-md mx-auto">
          <div className="relative flex flex-col rounded-lg border-0 shadow-lg bg-white outline-none focus:outline-none motion-safe:animate-popIn">
            <div className="flex items-start justify-between gap-3 p-5 rounded-t">
              <h3 className="ft-lg tab:ft-2xl text-[#202124] font-semibold my-auto">
                Session expirée
              </h3>
            </div>
            <div className="relative px-6 py-1.5 flex-auto">
              <p className="text-gray-600">
                Votre session a expiré ou n&apos;est plus valide — par exemple après
                une connexion sur un autre onglet ou un autre appareil. Reconnectez-vous
                pour continuer.
              </p>
            </div>
            <div className="flex items-center justify-end p-6 rounded-b gap-2">
              <Button size="LG" onClick={handleReconnect}>
                Se reconnecter
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-70 fixed inset-0 z-[59] bg-gray-700 motion-safe:animate-veilIn" />
    </>,
    document.getElementById('root-portal') || document.body
  );
};

export default SessionExpiredModal;
